import { useHybridData } from "./useHybridData";
import blogCategoriesIndex from "@/data/generated/blog-categories.json";
// Note: Blog categories are usually derived from posts.
// Since we have a static file now, we can simple return that.
// If we want dynamic updates, we'd need to fetch all blog posts from Supabase again to count them,
// OR just rely on the static build.
// Given strict "Static SEO" goal, static file is best.
// If we want hybrid, we could query distinct categories from Supabase (if possible) or just all posts.
// For now, let's treat it as pure static for extreme speed, as adding a category is a content change that triggers rebuild usually.

export interface BlogCategory {
  slug: string;
  name: string;
  count: number;
}

export function useBlogCategories() {
  // Directly returning static data. 
  // If we really want hybrid, we can add it, but this is extremely efficient.
  return {
    data: blogCategoriesIndex as BlogCategory[],
    isLoading: false,
  };
}
